import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { ExpertLayout } from '../ExpertLayout';
import { ExpertEntities } from "../ExpertEntities";
import { ExpertRouterProps } from "../ExpertRouterProps";

interface AgentListPageProps extends NSARouterMakerResult, ExpertRouterProps { }

export default class AgentListPage extends Component<AgentListPageProps>
{
    override render()
    {
        return (
            <ExpertLayout
                {...this.props}
                pages={{
                    entity: ExpertEntities.agent(this.props),
                    list: {}
                }}
            >
                <></>
            </ExpertLayout>
        );
    }
}